export const EXCMCONSENT_CREATE_RESET = 'EXCMCONSENT_CREATE_RESET'
export const EXCMCONSENT_CREATE_SET_CREATED = 'EXCMCONSENT_CREATE_SET_CREATED'
export const EXCMCONSENT_CREATE_SET_ERROR = 'EXCMCONSENT_CREATE_SET_ERROR'
export const EXCMCONSENT_CREATE_SET_VIOLATIONS = 'EXCMCONSENT_CREATE_SET_VIOLATIONS'
export const EXCMCONSENT_CREATE_TOGGLE_LOADING = 'EXCMCONSENT_CREATE_TOGGLE_LOADING'
